export default __webpack_public_path__ + "static/media/icono-topecoaseguro.db379abe.svg";